<template>
  <div class="header-wrapper">
    <!-- logo isquierda listar -->
    <div class="header-logo-wrapper">
      <div class="toggle-sidebar" @click="toggle_sidebar">
        <i class="fa fa-bars"></i>
      </div>
    </div>
    <!-- fin del logo -->
   <div class="nav-right left-header col horizontal-wrapper pl-0">
      <ul class="float-right align-self-end">
       <!-- color de pantalla -->
        <li>
        
            <i
              class="fa fa-moon-o"
              v-show="mixLayout == 'light-only'"
              @click="customizeMixLayout('dark-only')"
            ></i>
            <i
              class="fa fa-lightbulb-o"
              v-show="mixLayout == 'dark-only'"
              @click="customizeMixLayout('light-only')"
            ></i>
         
        </li>
         <!-- fin color de pantalla -->
         <!-- maximizar pantalla -->
        <li>
          <a
            class="text-dark"
            href="javascript:void(0)"
            @click="toggle_fullscreen()"
          >
            <feather type="maximize"></feather
          ></a>
        </li>
        <!-- fin maximizar pantalla -->

        <!-- perfil usuario -->
        <li>
        <b-nav-item-dropdown >
          <!-- Using 'button-content' slot -->
          <template #button-content>
          <i
              class="fa fa-user-circle mr-2"
              style="font-size:20px;color:#e5b921;"
            ></i>
            <!-- <span>{{ $store.state.usuarioDB.usr_usuario }}</span> -->
             <span class="font-roboto text-dark" style="font-size: 15px">
               <b>{{ $store.state.usuarioDB.nombre_persona }}</b>
              
              </span>
          </template>
          <li>
              <router-link to="/principal/perfil" class="px-2 text-dark"
                > <i
              class="fa fa-user px-2"
              
            ></i><span >Perfil</span></router-link
              >
            </li>
            <li @click="cerrarSesion()" class="p-3">
              <i
              class="fa fa-sign-in mr-2 "
              
            ></i>Salir
            </li>
        </b-nav-item-dropdown>
        </li>
        
      
      </ul>
    </div>
    

  </div>
</template>
<script>
var body = document.getElementsByTagName("body")[0];
import { mapState, mapActions, mapGetters } from "vuex";
// import app from "../main";
// import Bookmark from "./bookmark";
export default {
  name: "Search",
  data() {
    return {
      terms: "",
      searchOpen: false,
      searchResult: false,
      searchResultEmpty: false,
      close_sidebar_var: false,
      clicked: false,
      mobile_toggle: false,
      mobile_search: false,
      openbonusUI: false,
      openLevelmenu: false,
      openlanguage: false,
      mobile_accordian: false,
      mixLayout: "light-only",
    };
  },
  // components: {
  //   Bookmark,
  //   app
  // },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.searchData,
      megamenuItems: (state) => state.menu.megamenu,
    }),
    ...mapGetters(["estaActivo"]),
  },
  created() {
    this.leerToken();
  },
  methods: {
    ...mapActions(["cerrarSesion", "leerToken"]),
    toggle_sidebar() {
      this.$store.dispatch("menu/opensidebar");
    },
    setNavActive(item) {
      this.$store.dispatch("menu/setBonusNavActive", item);
    },
    openlangpicker() {
      this.openlanguage = !this.openlanguage;
    },
    openlevelmenu() {
      this.openLevelmenu = !this.openLevelmenu;
    },
    openmegamenu() {
      this.openbonusUI = !this.openbonusUI;
    },
    closeBonusUI() {
      this.openbonusUI = false;
    },
    search_open() {
      this.searchOpen = true;
    },
    search_close() {
      this.searchOpen = false;
    },
    searchterm: function() {
      this.$store.dispatch("menu/searchTerm", this.terms);
    },
    changeLocale(locale) {
      this.setLang(locale);
    },
    mobileaccordian() {
      this.mobile_accordian = !this.mobile_accordian;
    },
    /*logout: function () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          UserAuth.Logout();
          this.$router.replace("/auth/login");
        });
    },*/
    addFix() {
      body.classList.add("offcanvas");
      this.searchResult = true;
    },
    removeFix() {
      body.classList.remove("offcanvas");
      this.searchResult = false;
      this.terms = "";
    },
    toggle_fullscreen() {
      if (
        (document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)
      ) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    customizeMixLayout(val) {
      this.mixLayout = val;
      this.$store.dispatch("layout/setLayout", val);
    },
  },
  watch: {
    "$i18n.locale"(to, from) {
      if (from !== to) {
        this.$router.go(this.$route.path);
      }
    },
    menuItems: function() {
      this.terms ? this.addFix() : this.removeFix();
      if (!this.menuItems.length) this.searchResultEmpty = true;
      else this.searchResultEmpty = false;
    },
  },
};
</script>
